var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllustator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 30,
    viewBox: "0 0 48 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.4433 29.5223L42.7085 16.4082L39.9453 21.3372L44.5606 29.7762C44.6353 29.9106 44.7697 30.0002 44.9191 30.0002H47.1147C47.3537 29.9853 47.518 29.7463 47.4433 29.5223Z",
    fill: "#E43E2A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7791 11.4044C34.57 11.27 34.3011 11.3447 34.1816 11.5538L30.7164 17.7972L24.1146 29.6715C24.0399 29.806 24.1444 29.9852 24.2938 29.9852H34.9733C35.0181 29.9553 35.0629 29.9404 35.1077 29.9105L39.947 21.3371L42.7103 16.4081L34.7791 11.4044Z",
    fill: "#F0B500"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5003 6.16132L16.8962 0.0822471C16.7319 -0.022307 16.5079 0.127052 16.5527 0.321224L23.8416 29.6412C23.8864 29.8353 24.0656 29.9698 24.2598 29.9698H34.9542C35.0588 29.9698 35.1185 29.8652 35.0886 29.7756L26.5003 6.16132Z",
    fill: "#00C62D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1527 0.276633L0.066338 29.1634C-0.127834 29.5219 0.126084 29.97 0.5443 29.97H12.8966C13.0908 29.97 13.27 29.8654 13.3746 29.6862L20.6336 16.6767L26.5185 6.1466L16.9145 0.0824628C16.6456 -0.0818364 16.3021 0.00777952 16.1527 0.276633Z",
    fill: "#005BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustator);
export default __webpack_public_path__ + "static/media/illustator.1fafc986d8c365ebc20e38487ba01462.svg";
export { ForwardRef as ReactComponent };